/* Luxury Box PDP - logic for blocks/ai_gen_block_325b70b.liquid.
   Each block instance calls window.LuxboxPDP.define(tagName, config) after this file loads. */
(function(){
  window.LuxboxPDP = window.LuxboxPDP || {};
  window.LuxboxPDP.define = function(TAG, CFG){
    CFG = CFG || {}; const ID = CFG.id || String(TAG).replace(/^product-page-/, '');

    const cssEsc = (window.CSS && CSS.escape) ? CSS.escape : (s)=>String(s);

  function formatMoney(cents){
  const fmt = (window.__moneyFormat || '${{amount}}');
  const amount = (Math.round(cents || 0) / 100).toFixed(2);

  // Start from format string and replace all possible tokens globally
  let out = fmt;

  // No-decimals
  out = out.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round((cents || 0) / 100)));

  // No-decimals with comma separator (e.g., "1.234" in EU locales)
  out = out.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
                    Math.round((cents || 0) / 100).toLocaleString('de-DE'));

  // With comma separator (e.g., "1.234,56")
  out = out.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,
                    amount.replace('.', ','));

  // With apostrophe separator (e.g., "1'234.56")
  out = out.replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g,
                    amount.replace('.', "'"));

  // Default {{amount}}
  out = out.replace(/\{\{\s*amount\s*\}\}/g, amount);

  return out;
}

    // ===== Open-after-reload + Close handling (unchanged) =====
    function setSlideCartOpenClasses(){
      const panel = document.querySelector('.slidecarthq');
      const overlay = document.querySelector('.slidecarthq-overlay');
      if (panel){ panel.classList.remove('closed'); panel.classList.add('open'); panel.removeAttribute('aria-hidden'); }
      if (overlay){ overlay.classList.remove('closed'); overlay.classList.add('open'); overlay.removeAttribute('aria-hidden'); }
      document.documentElement.classList.add('no-scroll','is-locked');
      document.body.classList.add('no-scroll','is-locked');
    }
    function forceCloseSlideCart(){
      const panel = document.querySelector('.slidecarthq');
      const overlay = document.querySelector('.slidecarthq-overlay');
      if (panel){ panel.classList.remove('open'); panel.classList.add('closed'); panel.setAttribute('aria-hidden','true'); }
      if (overlay){ overlay.classList.remove('open'); overlay.classList.add('closed'); overlay.setAttribute('aria-hidden','true'); }
      document.documentElement.classList.remove('no-scroll','is-locked');
      document.body.classList.remove('no-scroll','is-locked');
    }
    function clearReopenInterval(){
      const iv = window.__slidecartReopenInterval;
      if (iv){ clearInterval(iv); window.__slidecartReopenInterval = null; }
    }
    function markManualClose(){
      try{ sessionStorage.removeItem('slidecartOpenAfterReload'); }catch(_){}
      document.documentElement.setAttribute('data-cart-manually-closed','1');
      clearReopenInterval();
    }
    (function openIfRequested(){
      try{
        if (!sessionStorage.getItem('slidecartOpenAfterReload')) return;
        let tries = 0;
        const tick = ()=>{
          if (document.documentElement.getAttribute('data-cart-manually-closed') === '1'){ clearReopenInterval(); return; }
          setSlideCartOpenClasses();
          tries++;
          if (document.querySelector('.slidecarthq.open') || tries > 40){
            clearReopenInterval();
            sessionStorage.removeItem('slidecartOpenAfterReload');
          }
        };
        window.__slidecartReopenInterval = setInterval(tick, 125);
        tick();
      }catch(_){}
    })();
    function handleCloseClick(e){
      e.preventDefault(); e.stopPropagation();
      markManualClose();
      forceCloseSlideCart();
      return false;
    }
    function wireCloseButtons(){
      document.addEventListener('click', function(e){
        const t = e.target.closest('[aria-label="close cart"], .slidecarthq-close, [data-cart-close], [data-drawer-close], .drawer__close, .slidecarthq-overlay');
        if (t){ handleCloseClick(e); }
      }, true);
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape'){ handleCloseClick(e); }
      });
    }
    wireCloseButtons();
    // ==================================================================

    class ProductPage extends HTMLElement{
      constructor(){
        super();
        this.quantity = 1;
        this.selectedVariant = null;
        this.selectedOptions = {};
        this._productData = null;
        this._ensurePromise = null;
        this.currentSlide = 0;
      }
      connectedCallback(){
        this.setupPopup();
        this.setupSlider();
        this.setupCollapsibles();
        this.setupVariants();
        this.setupQuantity();
        this.setupAddToCart();
        this.setupLightbox();
        this.setupThumbnails();
        this.setupSourcePopup();
        this.setupSizeGuideLink();
        this.setupStickyBar();
        this.setupDelivery();
        this.ensureProductData().then(()=>this.initializeDefaultVariant());
      }

      // ---- Labels (customizer-editable) ----
      get labels(){ return CFG.labels || {}; }

      // ---- Sourcing request modal (contact form rendered OUTSIDE the product form) ----
      setupSourcePopup(){
        const overlay = this.querySelector('[data-source-overlay]');
        if (!overlay) return;
        if (overlay.parentElement !== document.body) document.body.appendChild(overlay);
        const triggers = this.querySelectorAll('[data-source-trigger]');
        const closeBtn = overlay.querySelector('[data-source-close]');
        const close = ()=>{ overlay.classList.remove('active'); document.body.style.overflow=''; };
        const open = ()=>{
          const sizeInput = overlay.querySelector('[data-source-size]');
          const sel = this.querySelector('.ai-variant-option-'+ID+'[data-option-position="1"].selected');
          if (sizeInput && sel && !sizeInput.value) sizeInput.value = sel.dataset.optionValue || '';
          overlay.classList.add('active'); document.body.style.overflow='hidden';
        };
        triggers.forEach(t=>t.addEventListener('click', (e)=>{ e.preventDefault(); e.stopPropagation(); open(); }));
        closeBtn && closeBtn.addEventListener('click', close);
        overlay.addEventListener('click', (e)=>{ if (e.target === overlay) close(); });
        document.addEventListener('keydown', (e)=>{ if (e.key==='Escape' && overlay.classList.contains('active')) close(); });
        try{
          if (new URLSearchParams(location.search).get('contact_posted') === 'true'){
            const f = overlay.querySelector('[data-source-form]');
            const ok = overlay.querySelector('[data-source-success]');
            if (f) f.style.display = 'none';
            if (ok) ok.style.display = 'block';
            open();
          }
        }catch(_){}
      }

      setupSizeGuideLink(){
        const link = this.querySelector('[data-open-size-guide]');
        const item = this.querySelector('[data-size-guide]');
        if (!link || !item){ if (link) link.style.display='none'; return; }
        link.addEventListener('click', (e)=>{
          e.preventDefault();
          this.querySelectorAll('.ai-collapsible-item-'+ID+'').forEach(x=>x.classList.remove('active'));
          item.classList.add('active');
          item.scrollIntoView({ behavior:'smooth', block:'center' });
        });
      }

      // ---- Sticky mobile bar: reveals only once the inline CTA has scrolled out of view ----
      setupStickyBar(){
        const bar = this.querySelector('[data-sticky-bar]');
        const btn = this.querySelector('[data-add-to-cart]');
        if (!bar || !btn || !('IntersectionObserver' in window)) return;
        const stickyBtn = bar.querySelector('[data-sticky-atc]');
        stickyBtn && stickyBtn.addEventListener('click', ()=>{
          if (btn.disabled){ btn.scrollIntoView({ behavior:'smooth', block:'center' }); return; }
          btn.click();
        });
        let passed = false;
        const io = new IntersectionObserver((entries)=>{
          entries.forEach(en=>{
            passed = !en.isIntersecting && en.boundingClientRect.top < 0;
            bar.classList.toggle('visible', passed);
            bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
          });
        }, { threshold: 0 });
        io.observe(btn);
      }

      // ---- Delivery estimate: UPS transit days from Atlanta (30318), approximated by ZIP prefix ----
      setupDelivery(){
        const box = this.querySelector('[data-delivery]');
        if (!box) return;
        const input = box.querySelector('[data-delivery-zip]');
        const go = box.querySelector('[data-delivery-go]');
        const out = box.querySelector('[data-delivery-result]');
        const services = box.querySelectorAll('[data-service]');
        const handling = parseInt(box.dataset.handling || '1', 10);
        const esc = (x)=>String(x==null?'':x).replace(/[&<>"]/g, c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

        // Ground transit days by 3-digit ZIP prefix range (UPS zones out of Atlanta, approximate).
        const groundDays = (zip)=>{
          const p = parseInt(zip.slice(0,3), 10);
          const inR = (a,b)=> p>=a && p<=b;
          if (inR(300,319) || inR(350,369) || inR(370,374) || inR(290,299) || inR(280,289) || inR(320,329) || inR(376,379) || inR(398,399)) return 1;   // GA, AL, SC, NC, N FL, E TN
          if (inR(330,349) || inR(386,397) || inR(375,375) || inR(380,385) || inR(400,427) || inR(230,279) || inR(700,714) || inR(716,729)) return 2;   // S FL, MS, W TN, KY, VA/NC coast, LA, AR
          if (inR(430,499) || inR(600,658) || inR(730,799) || inR(150,229) || inR(5,149)) return 3;                                                    // OH, IN, MI, IL, MO, OK, TX, PA, NJ, DE, MD, DC, NY
          if (inR(500,599) || inR(660,699) || inR(800,885) || inR(10,69)) return 4;                                                                    // upper Midwest, KS/NE, Mountain, New England
          if (inR(889,966) || inR(970,994)) return 5;                                                                                                   // NV, CA, OR, WA
          if (inR(995,999) || inR(967,968)) return 6;                                                                                                   // AK, HI
          return null;
        };
        const addBiz = (d, n)=>{ const x = new Date(d); let k = 0; while (k < n){ x.setDate(x.getDate()+1); const w = x.getDay(); if (w !== 0 && w !== 6) k++; } return x; };
        const fmt = (d)=> d.toLocaleDateString('en-US', { weekday:'short', month:'short', day:'numeric' });

        const render = ()=>{
          const zip = (input.value || '').replace(/\D/g,'').slice(0,5);
          input.value = zip;
          if (zip.length < 5){ out.innerHTML = '<span class="ai-delivery-hint-'+ID+'">'+esc(box.dataset.hint || '')+'</span>'; return; }
          const sel = box.querySelector('[data-service].selected');
          const mode = sel ? sel.dataset.days : 'ground';
          const g = groundDays(zip);
          if (g === null){ out.innerHTML = '<span class="ai-delivery-err-'+ID+'">That doesn\'t look like a US ZIP code.</span>'; return; }
          let days, spread = 0;
          if (mode === 'ground'){ days = g; spread = g >= 3 ? 1 : 0; }
          else { days = parseInt(mode, 10) || 1; }
          if (mode !== 'ground' && g >= 6){ days = Math.max(days, 2); }
          const now = new Date();
          const shipDate = addBiz(now, handling);
          const from = addBiz(shipDate, days);
          const to = spread ? addBiz(from, spread) : from;
          const arrive = spread ? (fmt(from) + ' – ' + fmt(to)) : fmt(from);
          const label = sel ? sel.textContent.trim() : '';
          out.innerHTML = '<span class="ai-delivery-arrive-'+ID+'">Arrives '+esc(arrive)+'</span>'
            + '<span class="ai-delivery-sub-'+ID+'">'+esc(label)+' to '+esc(zip)+' · ships '+esc(fmt(shipDate))+'</span>';
          try{ localStorage.setItem('lb_zip', zip); }catch(_){}
        };
        box.dataset.hint = (out.textContent || '').trim();
        services.forEach(b=>b.addEventListener('click', ()=>{ services.forEach(x=>x.classList.remove('selected')); b.classList.add('selected'); render(); }));
        go.addEventListener('click', render);
        input.addEventListener('keydown', (e)=>{ if (e.key === 'Enter'){ e.preventDefault(); render(); } });
        input.addEventListener('input', ()=>{ if (input.value.replace(/\D/g,'').length === 5) render(); });
        try{ const z = localStorage.getItem('lb_zip'); if (z && /^\d{5}$/.test(z)){ input.value = z; render(); } }catch(_){}
      }

      updateStockUI(){
        const v = this.selectedVariant;
        const note = this.querySelector('[data-stock-note]');
        if (note){
          let txt = '';
          if (v && v.available && v.inventory_management && typeof v.inventory_quantity === 'number' && v.inventory_quantity > 0 && v.inventory_quantity <= (CFG.lowStock || 2)){
            txt = this.labels.onlyLeft.replace('{count}', v.inventory_quantity).replace('{size}', v.option1 || '');
          }
          note.textContent = txt;
        }
        this.refreshStores();
      }

      async refreshStores(){
        const v = this.selectedVariant;
        const wrap = this.querySelector('[data-stores]');
        if (!wrap || !v) return;
        if (String(wrap.dataset.variantId) === String(v.id)) return;
        const sectionId = wrap.dataset.sectionId;
        if (!sectionId) return;
        const reqId = (this._storesReq = (this._storesReq || 0) + 1);
        try{
          const url = `${location.pathname}?variant=${encodeURIComponent(v.id)}&sections=${encodeURIComponent(sectionId)}`;
          const r = await fetch(url);
          if (!r.ok) return;
          const j = await r.json();
          const html = j && j[sectionId];
          if (!html || reqId !== this._storesReq) return;
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-stores]');
          if (!fresh) return;
          const list = this.querySelector('[data-stores-list]');
          const freshList = fresh.querySelector('[data-stores-list]');
          if (list && freshList) list.innerHTML = freshList.innerHTML;
          wrap.style.display = fresh.style.display === 'none' ? 'none' : '';
          wrap.dataset.variantId = String(v.id);
        }catch(_){}
      }

      setupThumbnails(){
  const thumbs = this.querySelectorAll('.ai-product-thumb-'+ID+'');
  const mainImgWrapper = this.querySelector('[data-main-image]');
  if (!thumbs.length || !mainImgWrapper) return;
  const mainImg = mainImgWrapper.querySelector('img');
  if (!mainImg) return;
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      mainImg.src = thumb.dataset.thumbSrc;
      mainImg.setAttribute('data-full-src', thumb.dataset.thumbFull);
      mainImg.alt = thumb.dataset.thumbAlt;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
    thumb.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        thumb.click();
      }
    });
  });
}
updateNativeForm(){
  const variantInput = this.querySelector('[data-native-variant]');
  const qtyInput = this.querySelector('[data-native-quantity]');
  if (!variantInput || !qtyInput || !this.selectedVariant) return;

  variantInput.value = this.selectedVariant.id;
  qtyInput.value = this.quantity;
}
      async ensureProductData(){
        if (this._ensurePromise) return this._ensurePromise;
        this._ensurePromise = (async ()=>{
          const el = document.getElementById('product-min-'+ID+'');
          if (el){
            try{
              const j = JSON.parse(el.textContent || '{}');
              if (j && j.variants && j.variants.length){ this._productData = j; return j; }
            }catch(e){}
          }
          let handle = this.getAttribute('data-product-handle');
          if (!handle){
            const m = location.pathname.match(/\/products\/([^/?#]+)/);
            if (m) handle = decodeURIComponent(m[1]);
          }
          if (!handle) return null;
          try{
            const r = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers:{Accept:'application/json'} });
            if (r.ok){
              const js = await r.json();
              this._productData = {
                id: js.id,
                handle: js.handle,
                options: (js.options||[]).map(o=>o.name||o),
                variants: (js.variants||[]).map(v=>({
                  id: v.id,
                  available: !!v.available,
                  title: v.title,
                  option1: v.option1,
                  option2: v.option2,
                  option3: v.option3,
                  price: v.price,
                  compare_at_price: v.compare_at_price,
                  inventory_quantity: null,
                  inventory_management: null,
                  stores: []
                }))
              };
              return this._productData;
            }
          }catch(_){}
          return null;
        })();
        return this._ensurePromise;
      }
      getProductDataSync(){ return this._productData; }

      setupPopup(){
        const trigger = this.querySelector('[data-popup-trigger]');
        const overlay = this.querySelector('[data-popup-overlay]');
        const closeBtn = this.querySelector('[data-popup-close]');
        if (!trigger || !overlay) return;
        const close = ()=>{ overlay.classList.remove('active'); document.body.style.overflow=''; };
        trigger.addEventListener('click', (e)=>{ e.preventDefault(); e.stopPropagation(); overlay.classList.add('active'); document.body.style.overflow='hidden'; });
        closeBtn && closeBtn.addEventListener('click', close);
        overlay.addEventListener('click', (e)=>{ if (e.target === overlay) close(); });
        document.addEventListener('keydown', (e)=>{ if (e.key==='Escape' && overlay.classList.contains('active')) close(); });
      }

      setupSlider(){
        this.slides = this.querySelectorAll('.ai-slide-'+ID+'');
        this.dots = this.querySelectorAll('.ai-slider-dot-'+ID+'');
        if (!this.slides || this.slides.length <= 1) return;
        this.dots.forEach((d,i)=>d.addEventListener('click', ()=>this.goToSlide(i)));
        setInterval(()=>this.goToSlide((this.currentSlide+1)%this.slides.length), 4000);
      }
      goToSlide(i){
        this.currentSlide=i;
        this.slides.forEach((s,ix)=>s.classList.toggle('active', ix===i));
        this.dots.forEach((d,ix)=>d.classList.toggle('active', ix===i));
      }

      setupCollapsibles(){
        const items = this.querySelectorAll('.ai-collapsible-item-'+ID+'');
        items.forEach(it=>{
          const header = it.querySelector('.ai-collapsible-header-'+ID+'');
          header && header.addEventListener('click', ()=>{
            const active = it.classList.contains('active');
            items.forEach(x=>x.classList.remove('active'));
            if (!active) it.classList.add('active');
          });
        });
      }

      setupVariants(){
        const buttons = this.querySelectorAll('.ai-variant-option-'+ID+'');
        buttons.forEach(btn=>{
          btn.addEventListener('click', ()=>{
            if (btn.disabled) return;
            const name = btn.dataset.optionName;
            const value = btn.dataset.optionValue;
            const pos = btn.dataset.optionPosition;
            this.querySelectorAll(`[data-option-name="${name}"]`).forEach(s=>s.classList.remove('selected'));
            btn.classList.add('selected');
            this.selectedOptions[pos] = value;
            this.reconcileOptions(pos); // Sep 15: fix impossible size/condition combos
            this.updateSelectedVariantSync();
            this.updateAddToCartButton();
            this.updatePriceUI();
            this.updateStockUI();
            this.refreshOptionAvailability(); // Sep 15
          });
        });
      }

      async initializeDefaultVariant(){
        const data = await this.ensureProductData();
        if (!data || !data.variants || !data.variants.length) return;
        this.selectedVariant = data.variants.find(v=>v.available) || data.variants[0];
        if (this.selectedVariant){
          ['option1','option2','option3'].forEach((k,idx)=>{
            const val = this.selectedVariant[k]; if (!val) return;
            const pos = String(idx+1);
           const btn = this.querySelector(
  `.ai-variant-option-${ID}[data-option-position="${pos}"][data-option-value="${cssEsc(val)}"]`
);
            if (btn && !btn.disabled){
            this.querySelectorAll(
  `.ai-variant-option-${ID}[data-option-position="${pos}"]`
).forEach(s=>s.classList.remove('selected'));
              btn.classList.add('selected'); this.selectedOptions[pos]=val;
            }
          });
        }
        this.updateAddToCartButton();
        this.updatePriceUI();
        this.updateStockUI();
        this.updateNativeForm();
        this.refreshOptionAvailability(); // Sep 15
      }

      // ---- Sep 15: size/condition cross-filter ----
      // If the clicked value can't combine with the other current selections,
      // switch the OTHER options to a real variant that has the clicked value
      // (preferring one that's in stock). Prevents "11.5 + New" style dead combos
      // that left the price stale and Add to Cart enabled.
      reconcileOptions(pos){
        const d = this.getProductDataSync();
        if (!d || !d.variants) return;
        const sel = this.selectedOptions;
        const fits = v => ['1','2','3'].every(p => !sel[p] || v['option'+p] === sel[p]);
        if (d.variants.some(v => v.available && fits(v))) return;
        const alt = d.variants.find(v => v.available && v['option'+pos] === sel[pos])
                 || d.variants.find(v => v['option'+pos] === sel[pos]);
        if (!alt) return;
        ['1','2','3'].forEach(p=>{
          const val = alt['option'+p];
          if (!val || p === String(pos)) return;
          sel[p] = val;
          this.querySelectorAll(`.ai-variant-option-${ID}[data-option-position="${p}"]`)
            .forEach(s => s.classList.toggle('selected', s.dataset.optionValue === val));
        });
      }

      // Dim option buttons that don't form an in-stock variant with the current
      // selections (still clickable - clicking one re-routes via reconcileOptions),
      // and keep the "SIZE · <condition>" label in sync with the chosen condition.
      refreshOptionAvailability(){
        const d = this.getProductDataSync();
        if (!d || !d.variants) return;
        const sel = this.selectedOptions;
        this.querySelectorAll('.ai-variant-option-'+ID).forEach(b=>{
          if (b.disabled) return;
          const pos = String(b.dataset.optionPosition);
          const val = b.dataset.optionValue;
          const ok = d.variants.some(v =>
            v['option'+pos] === val && v.available &&
            ['1','2','3'].every(p => p === pos || !sel[p] || v['option'+p] === sel[p])
          );
          b.classList.toggle('lb-combo-off', !ok);
        });
        // Oct 19: keep each size chip's price on the variant for that size AND the
        // selected condition (falling back to the cheapest in-stock one for the size),
        // so the chip can never undercut the headline price.
        this.querySelectorAll('.ai-variant-option-'+ID+'[data-option-position="1"]').forEach(b=>{
          if (b.disabled) return;
          const subEl = b.querySelector('.ai-variant-sub-'+ID);
          if (!subEl) return;
          const val = b.dataset.optionValue;
          const exact = d.variants.find(v =>
            v.option1 === val && v.available &&
            ['2','3'].every(p => !sel[p] || v['option'+p] === sel[p])
          );
          let cents = null;
          if (exact){
            cents = exact.price;
          } else {
            d.variants.forEach(v=>{
              if (v.option1 !== val || !v.available) return;
              if (cents === null || v.price < cents) cents = v.price;
            });
          }
          if (cents === null) return;
          subEl.textContent = formatMoney(cents).replace(/\.00\b/, '');
        });
        const sub = this.querySelector('.ai-variant-label-sub-'+ID);
        if (sub && sel['2']) sub.textContent = '· ' + sel['2'];
        if (!document.getElementById('lb-combo-css')){
          const st = document.createElement('style');
          st.id = 'lb-combo-css';
          st.textContent = '.lb-combo-off{opacity:.45}';
          document.head.appendChild(st);
        }
      }

  updateSelectedVariantSync(){
  const d = this.getProductDataSync();
  if (!d || !d.variants) return;

  this.selectedVariant = d.variants.find(v =>
    (!this.selectedOptions['1'] || v.option1 === this.selectedOptions['1']) &&
    (!this.selectedOptions['2'] || v.option2 === this.selectedOptions['2']) &&
    (!this.selectedOptions['3'] || v.option3 === this.selectedOptions['3'])
  ) || null;

  this.updateNativeForm();
}

      updatePriceUI(){
        const v = this.selectedVariant;
        const priceEl   = this.querySelector('[data-variant-price]');
        const compareEl = this.querySelector('[data-variant-compare]');
        if (!priceEl || !v) return;
        priceEl.textContent = formatMoney(v.price ?? 0);
        const sticky = this.querySelector('[data-sticky-price]');
        if (sticky) sticky.textContent = formatMoney(v.price ?? 0);
        const ship = this.querySelector('[data-ship-line]');
        if (ship){
          const th = parseInt(ship.dataset.shipThreshold || '0', 10);
          const sub = ship.querySelector('[data-ship-sub]');
          if (sub && th > 0) sub.textContent = ((v.price || 0) >= th) ? (ship.dataset.shipQualifies || '') : (ship.dataset.shipBelow || '');
        }
        const showCompare = !!(v.compare_at_price && v.compare_at_price > v.price);
        if (compareEl){
          compareEl.style.display = showCompare ? 'inline' : 'none';
          if (showCompare) compareEl.textContent = formatMoney(v.compare_at_price);
        }
        const saveEl = this.querySelector('[data-variant-save]');
        if (saveEl){
          saveEl.style.display = showCompare ? 'inline-flex' : 'none';
          if (showCompare) saveEl.textContent = 'Save ' + formatMoney(v.compare_at_price - v.price).replace(/\.00\b/, '');
        }
      }

      setupQuantity(){
        const input = this.querySelector('[data-quantity-input]');
        const dec = this.querySelector('[data-quantity-decrease]');
        const inc = this.querySelector('[data-quantity-increase]');
        if (!input || !dec || !inc) return;
        dec.addEventListener('click', ()=>{ 
  this.quantity = Math.max(1, this.quantity-1); 
  input.value=this.quantity; 
  this.updateNativeForm();
});
inc.addEventListener('click', ()=>{ 
  this.quantity = this.quantity+1; 
  input.value=this.quantity; 
  this.updateNativeForm();
});
input.addEventListener('change', (e)=>{ 
  this.quantity = Math.max(1, parseInt(e.target.value)||1); 
  input.value=this.quantity; 
  this.updateNativeForm();
});
      }

      setupAddToCart(){
        const btn = this.querySelector('[data-add-to-cart]');
        if (!btn) return;
        btn.addEventListener('click', async ()=>{ await this.handleAddToCart(btn); });
      }

      updateAddToCartButton(){
        const btn = this.querySelector('[data-add-to-cart]'); if (!btn) return;
        const sections = this.querySelectorAll('.ai-variant-section-'+ID+'');
        const requireSel = sections.length>0;
        const allSel = !requireSel || Array.from(sections).every(s=>s.querySelector('.ai-variant-option-'+ID+'.selected'));
        const available = this.selectedVariant ? !!this.selectedVariant.available : false; // Sep 15: no matching variant = not buyable
        const pd = this.getProductDataSync();
        const anyAvailable = !pd || !pd.variants || pd.variants.some(v=>v.available);
        btn.disabled = (requireSel && !allSel) || !available || !anyAvailable;
        btn.textContent = !anyAvailable ? this.labels.soldOut : ((!allSel && requireSel) ? this.labels.selectOptions : (!available ? this.labels.soldOut : this.labels.atc));
        const stickyBtn = this.querySelector('[data-sticky-atc]');
        if (stickyBtn){ stickyBtn.disabled = !available; stickyBtn.textContent = available ? this.labels.atc : this.labels.soldOut; }
      }

      async handleAddToCart(btn){
        const product = await this.ensureProductData();
        if (!product || !product.variants || !product.variants.length){ alert('Product data unavailable.'); return; }

        const hasRealOptions = !(product.options && product.options.length===1 && product.options[0]==='Title');
        if (hasRealOptions){
          const sections = this.querySelectorAll('.ai-variant-section-'+ID+'');
          const allSelected = Array.from(sections).every(s=>s.querySelector('.ai-variant-option-'+ID+'.selected'));
          if (!allSelected){ alert('Please select all required options'); return; }
        }
        if (!this.selectedVariant){ this.selectedVariant = product.variants.find(v=>v.available) || product.variants[0]; }
        if (!this.selectedVariant){ alert('No variant found.'); return; }
        if (!this.selectedVariant.available){ alert('This variant is currently unavailable'); return; }

        const qty = Math.max(1, this.quantity || 1);

        const orig = btn.textContent;
        btn.disabled = true; btn.textContent = 'ADDING...';

        const safety = setTimeout(()=>{ btn.disabled=false; btn.textContent = orig; }, 8000);

        try{
          const res = await fetch('/cart/add.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ id: this.selectedVariant.id, quantity: qty })
          });
          if (!res.ok){
            let msg = 'Failed to add to cart';
            try{
              const j = await res.json();
              if (j && (j.description || j.message)) msg = j.description || j.message;
            }catch(_){}
            throw new Error(msg);
          }
          clearTimeout(safety);
          btn.disabled = false; btn.textContent = orig;
          this.openCartDrawer();
        }catch(e){
          alert(e.message || 'Something went wrong adding to cart.');
          clearTimeout(safety);
          btn.disabled = false; btn.textContent = orig;
        }
      }

      openCartDrawer(){
        // Pipeline's native drawer (sections/cart-drawer.liquid): refresh cart state, then open.
        const native = document.querySelector('[data-drawer="drawer-cart"]');
        if (native){
          const cartUrl = ((window.theme && window.theme.routes && window.theme.routes.cart) || '/cart') + '.js';
          const open = ()=>{ try{ native.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles:false })); }catch(_){ window.location.href = '/cart'; } };
          fetch(cartUrl, { headers:{ 'Accept':'application/json' } })
            .then(r=>r.json())
            .then(cart=>{
              document.dispatchEvent(new CustomEvent('theme:cart:change', { detail:{ cart }, bubbles:true }));
              open();
            })
            .catch(open);
          return;
        }
        // Fallback for third-party cart apps; last resort is the cart page.
        const before = document.querySelector('.kaching-cart[open], .kaching-cart.open, .kaching-cart[aria-modal="true"]');
        try{ document.dispatchEvent(new CustomEvent('cart:refresh')); }catch(_){}
        try{ document.dispatchEvent(new CustomEvent('kaching-cart:open')); }catch(_){}
        const icon = document.querySelector('a[href="/cart"], a[href$="/cart"], [data-cart-toggle], .cart-toggle, [aria-label*="cart" i]');
        if (icon){ try{ icon.click(); }catch(_){ } }
        setTimeout(()=>{
          const drawer = document.querySelector('.kaching-cart, [class*="cart-drawer"], .slidecarthq, [data-cart-drawer]');
          const visible = drawer && drawer.getBoundingClientRect().width > 0 && getComputedStyle(drawer).visibility !== 'hidden';
          if (!visible && !before) window.location.href = '/cart';
        }, 700);
      }

      setupLightbox(){
        const wrap = this.querySelector('[data-main-image]');
        const overlay = this.querySelector('[data-lightbox-overlay]');
        const closeBtn = this.querySelector('[data-lightbox-close]');
        const stage = this.querySelector('[data-lightbox-stage]');
        const img = this.querySelector('[data-lightbox-image]');
        const positionCloseButton = () => {
  if (!img || !closeBtn) return;

  const rect = img.getBoundingClientRect();

  closeBtn.style.top  = `${rect.top + 8}px`;
  closeBtn.style.left = `${rect.right - 32}px`;
};
        if(!wrap || !overlay || !stage || !img) return;

        const open = (src)=>{
  img.onload = () => {
    this._scale = 1;
    this._tx = 0;
    this._ty = 0;
    apply();
    positionCloseButton();
  };
  img.src = src;

  overlay.classList.add('active');
  window.addEventListener('resize', positionCloseButton);
  document.body.style.overflow = 'hidden';
};
        const close = ()=>{ overlay.classList.remove('active'); document.body.style.overflow=''; img.src = ''; };
        const apply = ()=>{ img.style.transform = `translate(${this._tx}px, ${this._ty}px) scale(${this._scale})`; 
       positionCloseButton();
      };

        wrap.addEventListener('click', ()=>{ const main = wrap.querySelector('img'); if(!main) return; const full = main.getAttribute('data-full-src') || main.src; open(full); });
        closeBtn.addEventListener('click', close);
        overlay.addEventListener('click', (e)=>{ if(e.target === overlay) close(); });
        document.addEventListener('keydown', (e)=>{ if(e.key==='Escape' && overlay.classList.contains('active')) close(); });

        this._scale = 1; this._tx = 0; this._ty = 0;
        let dragging = false, sx=0, sy=0, ox=0, oy=0;

        stage.addEventListener('wheel', (e)=>{ e.preventDefault(); const delta = -e.deltaY; const factor = delta>0 ? 1.1 : 0.9; const prev = this._scale; let next = Math.min(8, Math.max(1, prev * factor)); const rect = img.getBoundingClientRect(); const cx = e.clientX - rect.left; const cy = e.clientY - rect.top; this._tx = (this._tx - cx) * (next/prev) + cx; this._ty = (this._ty - cy) * (next/prev) + cy; this._scale = next; apply(); }, { passive:false });

        stage.addEventListener('mousedown', (e)=>{ e.preventDefault(); dragging = true; stage.style.cursor='grabbing'; sx = e.clientX; sy = e.clientY; ox = this._tx; oy = this._ty; });
        window.addEventListener('mousemove', (e)=>{ if(!dragging) return; this._tx = ox + (e.clientX - sx); this._ty = oy + (e.clientY - sy); apply(); });
        window.addEventListener('mouseup', ()=>{ dragging=false; stage.style.cursor='grab'; });

        let touchStartDist = 0, baseScale = 1;
        stage.addEventListener('touchstart', (e)=>{
          if(e.touches.length===1){
            dragging = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY; ox = this._tx; oy = this._ty;
          } else if(e.touches.length===2){
            dragging = false; const dx = e.touches[1].clientX - e.touches[0].clientX; const dy = e.touches[1].clientY - e.touches[0].clientY; touchStartDist = Math.hypot(dx,dy); baseScale = this._scale;
          }
        }, { passive:false });
        stage.addEventListener('touchmove', (e)=>{
          e.preventDefault();
          if(e.touches.length===1 && dragging){
            this._tx = ox + (e.touches[0].clientX - sx); this._ty = oy + (e.touches[0].clientY - sy); apply();
          } else if(e.touches.length===2){
            const dx = e.touches[1].clientX - e.touches[0].clientX; const dy = e.touches[1].clientY - e.touches[0].clientY; const dist = Math.hypot(dx,dy);
            let next = Math.min(8, Math.max(1, baseScale * (dist / touchStartDist))); this._scale = next; apply();
          }
        }, { passive:false });
        stage.addEventListener('touchend', ()=>{ dragging=false; }, { passive:true });
      }
    }
    if (!customElements.get(TAG)) customElements.define(TAG, ProductPage);
  
  };
})();